import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src2131828011/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
